import React, { useEffect, useState } from 'react';
import { getText } from '../i18n';
import { getNextParisReset, getTimeUntil } from '../utils/daily';

export default function DailyFlagCountdown({ language }) {
  const [timeLeft, setTimeLeft] = useState(getTimeUntil(getNextParisReset()));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeUntil(getNextParisReset()));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="daily-countdown">
      <span>{getText('dailyCountdownLabel', language)}</span>
      <strong>{timeLeft}</strong>
    </div>
  );
}
